import React from 'react'
import Loader from './Loader'

export * from './Loader'
export default React.memo(Loader)
